import { render, staticRenderFns } from "./CommissionersList.vue?vue&type=template&id=23f53385&scoped=true&"
import script from "./CommissionersList.vue?vue&type=script&lang=js&"
export * from "./CommissionersList.vue?vue&type=script&lang=js&"
import style0 from "./CommissionersList.vue?vue&type=style&index=0&id=23f53385&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f53385",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
